Vue.component('leaderboardlegacyteam', {
  template: templates.leaderBoardLegacyTeam,
  data() {
    return {
      model: {
        teams: [],
        top: [],
        medals: [],
        isLoggedIn: false,
        selectedOption: 0,
        options: [
          { text: '2v2', value: '2v2' },
          { text: '3v3', value: '3v3' },
          { text: '4v4', value: '4v4' },
          { text: 'Squad', value: 'squad' }
        ],
        currentPage: 0,
        limit: 50,
        totalPages: 0,
        totalTeams: 0
      },
      cancelTokenSource: null
    };
  },
  watch: {
    'model.selectedOption': function(newVal) {
      const c = this;
      c.model.currentPage = 0;
      c.get();
    }
  },
  mounted() {
    const c = this;
    c.get();
    c.getMedals();

    $('[data-view="viewer-dashboard"]').on(
      'click',
      '[data-component="leaderBoardLegacyTeam"] .medal',
      function (e) {
        c.show($(this).clone());
      }
    );

    $('[data-view="viewer-dashboard"]').on(
      'click',
      '.view-element',
      function () {
        c.hide();
      }
    );
  },
  beforeDestroy() {
    const c = this;

    if (c.cancelTokenSource) {
      c.cancelTokenSource.cancel('Request canceled due to component destruction.');
    }
  },
  methods: {
    get() {
      const c = this;

      if (c.cancelTokenSource) {
        c.cancelTokenSource.cancel('Previous request canceled.');
      }

      c.cancelTokenSource = axios.CancelToken.source();

      const selectedBattleType = c.model.options[c.model.selectedOption].value;
      const offset = c.model.currentPage * c.model.limit;

      legacyBattleService
        .getTeamLeaderboard(selectedBattleType, c.model.limit, offset)
        .then(function (response) {
          console.log('Legacy Team Leaderboard Response:', response.data);

          let data = response.data;

          if (!Array.isArray(data) || data.length === 0) {
            c.model.teams = [];
            c.model.top = [];
            c.model.totalTeams = 0;
            c.model.totalPages = 0;
            return;
          }

          // Process team leaderboard data
          let teams = data;

          // Add visual rank and format data
          teams.forEach((team, index) => {
            team.rank = offset + index + 1;
            team.achievements = team.achievements || [];
            team.winRate = team.winRate || 0;
            team.total = (team.wins || 0) + (team.losses || 0);

            // Format achievements with image paths
            team.achievements = team.achievements.map(medalId => ({
              id: medalId,
              image: `${root}/images/medals/${medalId}.png`
            }));
          });

          c.model.teams = teams;
          c.model.totalTeams = teams.length;
          c.model.totalPages = Math.ceil(c.model.totalTeams / c.model.limit);

          // Set top 3 (reorder as: 2nd, 1st, 3rd for visual prominence)
          if (teams.length > 0) {
            let first = teams.slice(0, 1);
            let second = teams.slice(1, 2);
            let third = teams.slice(2, 3);
            c.model.top = [...(second.length ? second : []), ...first, ...(third.length ? third : [])];
          }

          c.model.isLoggedIn = true;
        })
        .catch(function (error) {
          console.log('Error fetching legacy team leaderboard:', error);
          c.model.teams = [];
          c.model.top = [];
          c.model.totalTeams = 0;
          c.model.totalPages = 0;
        });
    },
    getMedals() {
      const c = this;

      medalService
        .get()
        .then(function (response) {
          for (let medal of response.data) {
            medal.image = `${root}/images/medals/${medal.id}.png`;
          }
          c.model.medals = response.data;
        })
        .catch(function (error) {
          console.log('Error fetching medals:', error);
        });
    },
    nextPage() {
      const c = this;
      if (c.model.currentPage < c.model.totalPages - 1) {
        c.model.currentPage++;
        c.get();
        window.scrollTo(0, 0);
      }
    },
    previousPage() {
      const c = this;
      if (c.model.currentPage > 0) {
        c.model.currentPage--;
        c.get();
        window.scrollTo(0, 0);
      }
    },
    goToPage(pageNumber) {
      const c = this;
      if (pageNumber >= 0 && pageNumber < c.model.totalPages) {
        c.model.currentPage = pageNumber;
        c.get();
        window.scrollTo(0, 0);
      }
    },
    show($element) {
      const c = this;
      let id = $element.data('id');
      let video = `/videos/medals/${id}.webm`;
      let name = '';

      for (let medal of c.model.medals) {
        if (medal.id === id) {
          name = medal.name;
          break;
        }
      }

      if ($('[data-view="viewer-dashboard"] [data-modal="medal-modal"]').length) {
        $('[data-view="viewer-dashboard"]').find('[data-modal="medal-modal"]').remove();
      }

      $('[data-view="viewer-dashboard"]').append(`
        <div class="view-element" data-modal="medal-modal">
          <div class="modal">
            <video autoplay muted loop>
              <source src="${video}" type="video/webm" />
              Your browser does not support the video tag.
            </video>
            <h3>${name}</h3>
          </div>
        </div>
      `);
    },
    hide() {
      $('[data-view="viewer-dashboard"]').find('[data-modal="medal-modal"]').remove();
    }
  }
});
